import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import RenderError from "../RenderError";

const Input = (props) => {
    const {
        classNameDiv,
        label,
        classNameLabel,
        className,
        name,
        type,
        value,
        onChange,
        disabled,
        readOnly,
        required,
        accept,
        placeholder
    } = props;

    const ref = React.createRef();

    const [requiredProps, setRequiredProps] = useState([])
    const [errorProps, seterrorProps] = useState("")
    let temp = []
    useEffect(() => {
        for (const key in Input.propTypes) { //eslint-disable-line react/forbid-foreign-prop-types
            if (!Input.propTypes[key].isRequired) { //eslint-disable-line react/forbid-foreign-prop-types
                temp.push(key)
            }
        }
        if (temp.length > 0) {
            setRequiredProps(temp)
        }
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (requiredProps.length > 0) {
            for (const key in requiredProps) {
                if (!props[requiredProps[key]]) {
                    seterrorProps(requiredProps[key]);
                    break;
                }
            }
        }
    }, [requiredProps]); //eslint-disable-line react-hooks/exhaustive-deps

    if (errorProps) {
        return <RenderError component="Input" err={errorProps} />
    }

    return (
        <>
            <div className={`${classNameDiv}`}>
                {
                    label && (
                        <label htmlFor={name} className={`${classNameLabel}`}>
                            {label} {required && <span style={{ color: 'red' }}>*</span>}
                        </label>
                    )
                }

                <input
                    ref={ref}
                    className={`${className}`}
                    id={name}
                    name={name}
                    type={type}
                    // defaultValue={value}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    readOnly={readOnly}
                    required={required}
                    accept={accept}
                    placeholder={placeholder}
                />
            </div>
        </>
    )
}
Input.defaultProps = {
    type: 'text',
    classNameDiv: '',
    classNameLabel: '',
    className: '',
};

Input.propTypes = {
    classNameDiv: PropTypes.string,
    label: PropTypes.string,
    classNameLabel: PropTypes.string,
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    type: PropTypes.string.isRequired,
    accept: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.string,
    readOnly: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
}
export default Input;